import * as React from 'react';
import { twMerge } from 'tailwind-merge';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  options: SelectOption[];
  selectSize?: 'sm' | 'md';
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ options, selectSize = 'md', className, ...rest }, ref) => {
    const sizeClasses = selectSize === 'sm' ? 'text-xs py-1.5 pl-2.5 pr-7' : 'text-[13px] py-2 pl-3 pr-8';

    return (
      <select
        ref={ref}
        className={twMerge(
          'bg-surface-2 text-text-1 cursor-pointer appearance-none rounded-[4px] border outline-none',
          'border-stroke-1',
          sizeClasses,
          className,
        )}
        style={{
          backgroundImage:
            'linear-gradient(45deg, transparent 50%, currentColor 50%), linear-gradient(135deg, currentColor 50%, transparent 50%)',
          backgroundPosition: 'right 10px top 55%, right 6px top 55%',
          backgroundSize: '4px 4px, 4px 4px',
          backgroundRepeat: 'no-repeat',
        }}
        {...rest}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    );
  },
);
Select.displayName = 'Select';
